import { getCreateError, isCreating, getEntity } from './_utils'

export const creatingPartner = isCreating('/partners')

export const getCreatePartnerError = getCreateError('/partners')

export const getPartner = getEntity('partners')
